app.service('basketPartnerSubscription', function (modal, loading, broker) {
	function update(options) {
		$.ajax({
			url: '/cart-update-partner-subscription-quantity.ltr',
			method: 'POST',
			dataType: 'json',
			data: {
				partnerSubscriptionId: options.partnerSubscriptionId,
				relatedPromotionIdentifier: options.relatedPromotionIdentifier,
				productId: options.productId,
				quantity: options.quantity
			},
			success: function (json) {
				if (json && json.responseJSON && json.responseJSON.status == 'FAIL') {
					modal.generate({
						id: 'standalone-service-message',
						content: '<p>' + json.responseJSON.messages + '</p>',
						callbackClose: function () {
							broker.trigger('REFRESH_BASKET_VIEW');
						},
						buttons: [
							{
								text: 'Rozumiem',
								click: function () {
									modal.close(false);
								},
								cssClass: 'btn btn-second'
							}
						]
					});
				} else {
					broker.trigger('REFRESH_BASKET_VIEW');
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd zmiany ilości usług partnerskich. Spróbuj ponownie', function () {
					broker.trigger('REFRESH_BASKET_VIEW');
				});
			}
		});
	}

	function remove(options) {
		cartBox.abortRefresh();
		$.ajax({
			url: '/remove-partner-subscription.ltr',
			method: 'POST',
			dataType: 'json',
			data: {
				partnerSubscriptionId: options.partnerSubscriptionId,
				productId: options.productId,
				relatedPromotionIdentifier: options.relatedPromotionIdentifier
			},
			cache: false,
			complete: function (json) {
				if (json.responseJSON && json.responseJSON.status == 'FAIL') {
					modal.alert(json.messages);
				} else {
					broker.trigger('REFRESH_BASKET_VIEW');
				}
			}
		});
	}

	return {
		update, remove
	};
});
